import { HELP_CENTER_URI } from './constants';

const helpCenterUrl = (activeLanguage) => {
    return `${HELP_CENTER_URI}/${activeLanguage}/`;
};

const redirectToHelpCenter = (activeLanguage) => {
    window.open(helpCenterUrl(activeLanguage), '_self');
};

export { helpCenterUrl, redirectToHelpCenter };
